<div class="container-fluid full-page">
  <div *ngIf="data?.globalCompetencyLeader; else noData">
    <div class="card" style="margin-left: 0px" *ngFor="let leader of data?.globalCompetencyLeader">
      <div class="circle">
        <span>{{ getInitials(leader.name) }}</span>
      </div>
      <div class="names">
        <ng-container>
          <p class="card-text">
            <span> {{ leader.name }} </span>
          </p>
          <p class="titlename">Global Competency Leader</p>
          <p class="titlename">{{ leader.id }}</p>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #noData>
    <span class="justify-content-center">No data Found</span>
  </ng-template>
  <div *ngIf="data?.globalSubCompetencyLeader !== null">
    <div class="vl"></div>
    <div class="row">
      <div class="card" *ngFor="let leader of data?.globalSubCompetencyLeader" style="margin-left: 15px;">
        <div class="circle">
          <span>{{ getInitials(leader.name) }}</span>
        </div>
        <div class="names">
          <ng-container>
            <p class="card-text">
              <span> {{ leader.name }} </span>
            </p>
            <p class="titlename">Global SubCompetency Leader</p>
            <p class="titlename">{{ leader.id }}</p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="data?.managers !== null">
    <div class="vl"></div>
    <div class="p-1 w-100"></div>
    <div style="padding-left: 30px; padding-bottom: 30px" class="row applyIt">
      <div class="card_location mb-3">
        <h6></h6>
      </div>
      <div class="card_location mb-3" *ngFor="let locationId of getLocationIds()">
        <div class="location-names">
          <span class="flag-icon flag-icon-{{
            locationFlagMap[getFlagName(getLocationName(locationId))]
              | lowercase
          }}"></span>
          <h6>{{ getLocationName(locationId) }}</h6>
        </div>
      </div>
      <div *ngIf="peopleStream.length > 0" style="margin-left: 30px;">
        <span class="stream-title mb-3">People Stream</span>
        <div class="row manager_role_data">
          <ng-container *ngFor="let role of peopleStream">
            <div class="row manager_role_data">
              <div class="card mb-4 mr-0 justify-content-center">
                <h6>{{ role }}</h6>
              </div>
              <div class="horline"></div>
              <div class="separationofroles" *ngFor="let location of getLocationIds()">
                <ng-container *ngIf="
                  getManagersByRoleAndLocation(role, location).length > 0;
                  else noManagers">
                  <div class="card mb-4 card-sb manager">
                    <div class="circle">
                      <span>{{
                        getInitials(
                        getManagersByRoleAndLocation(role, location)[0].name
                        )
                        }}</span>
                    </div>
                    <div class="names">
                      <p class="card-text">
                        {{ getManagersByRoleAndLocation(role, location)[0].name }}
                      </p>
                      <p class="titlename" [ngClass]="{'long-text':shouldDecreaseFontSize(role)}">{{ role }}</p>
                      <p class="titlename">
                        {{ getManagersByRoleAndLocation(role, location)[0].id }}
                      </p>
                    </div>
                    <button class="btn add-template btnedit">
                      <i class="fas fa-pencil-alt" style="cursor: pointer" (click)="
                        openDialog(
                          getManagersByRoleAndLocation(role, location)[0]
                        )
                      "></i>
                    </button>
                  </div>
                </ng-container>
                <ng-template #noManagers>
                  <div class="card mb-4 justify-content-center">
                    <div class="not-answered">
                      <span>NA</span>
                    </div>
                    <div class="btnedit">
                      <button class="btn add-template">
                        <i class="fas fa-pencil-alt" style="margin-left: 5px; cursor: pointer"
                          (click)="openDialogToAdd(role, location)">
                        </i>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Functional Stream -->
      <div *ngIf="functionalStream.length > 0" style="margin-left: 30px;">
        <span class="stream-title">Functional Stream</span>
        <div class="row manager_role_data">
          <ng-container *ngFor="let role of functionalStream">
            <div class="row manager_role_data">
              <div class="card mb-4 mr-0 justify-content-center">
                <h6>{{ role }}</h6>
              </div>
              <div class="horline"></div>
              <div class="separationofroles" *ngFor="let location of getLocationIds()">
                <ng-container *ngIf="getManagersByRoleAndLocation(role, location).length > 0;else noManagers">
                  <div class="card mb-4 card-sb manager">
                    <div class="circle">
                      <span>{{getInitials(getManagersByRoleAndLocation(role, location)[0].name) }}</span>
                    </div>
                    <div class="names">
                      <p class="card-text">
                        {{ getManagersByRoleAndLocation(role, location)[0].name }}
                      </p>
                      <p class="titlename" [ngClass]="{'long-text':shouldDecreaseFontSize(role)}">{{ role }}</p>
                      <p class="titlename">
                        {{ getManagersByRoleAndLocation(role, location)[0].id }}
                      </p>
                    </div>
                    <button class="btn add-template btnedit">
                      <i class="fas fa-pencil-alt" style="cursor: pointer" (click)="openDialog(getManagersByRoleAndLocation(role, location)[0])"></i>
                    </button>
                  </div>
                </ng-container>
                <ng-template #noManagers>
                  <div class="card mb-4 justify-content-center">
                    <div class="not-answered">
                      <span>NA</span>
                    </div>
                    <div class="btnedit">
                      <button class="btn add-template">
                        <i class="fas fa-pencil-alt" style="margin-left: 5px; cursor: pointer"
                          (click)="openDialogToAdd(role, location)">
                        </i>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Technical Stream -->
      <div *ngIf="technicalStream.length > 0" style="margin-left: 30px;">
        <span class="stream-title">Technical Stream</span>
        <div class="row manager_role_data">
          <ng-container *ngFor="let role of technicalStream">
            <div class="row manager_role_data">
              <div class="card mb-4 mr-0 justify-content-center">
                <h6>{{ role }}</h6>
              </div>
              <div class="horline"></div>
              <div class="separationofroles" *ngFor="let location of getLocationIds()">
                <ng-container *ngIf=" getManagersByRoleAndLocation(role, location).length > 0;
                  else noManagers ">
                 <div class="card mb-4 card-sb manager">
                    <div class="circle">
                      <span>{{
                        getInitials(
                        getManagersByRoleAndLocation(role, location)[0].name
                        )
                        }}</span>
                    </div>
                    <div class="names">
                      <p class="card-text">
                        {{ getManagersByRoleAndLocation(role, location)[0].name }}
                      </p>
                      <p class="titlename" [ngClass]="{'long-text':shouldDecreaseFontSize(role)}">{{ role }}</p>
                      <p class="titlename">
                        {{ getManagersByRoleAndLocation(role, location)[0].id }}
                      </p>
                    </div>
                    <button class="btn add-template btnedit">
                      <i class="fas fa-pencil-alt" style="cursor: pointer" (click)="
                        openDialog(
                          getManagersByRoleAndLocation(role, location)[0])">
                      </i>
                    </button>
                  </div>
                </ng-container>
                <ng-template #noManagers>
                  <div class="card mb-4 justify-content-center">
                    <div class="not-answered">
                      <span>NA</span>
                    </div>
                    <div class="btnedit">
                      <button class="btn add-template">
                        <i class="fas fa-pencil-alt" style="margin-left: 5px; cursor: pointer"
                          (click)="openDialogToAdd(role, location)">
                        </i>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template let-data #updateManager>
  <div *ngIf="adminRole == 0" class="p-3">
    <span *ngIf="adminRole == 0" class="h1">{{
      selectedRole
      }}</span>
  </div>
  <div *ngIf="adminRole == 0" class="employee-search d-flex justify-content-start col-3 pl-3 pr-3">
    <div class="input-group">
      <div class="emp_search_container flex-column flex-md-row">
        <span class="h3 fw-500">Enter Employee ID/ Name</span>
        <div class="search-bar mx-1">
          <input type="text" class="form-control" aria-label="Number" matInput [(ngModel)]="currentEmployee"
            (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
            [matAutocomplete]="partner" />
          <button type="submit" class="msicon append_button">
            <span class="material-symbols-outlined"> search</span>
          </button>
        </div>
        <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
          (optionSelected)="setCurrentEmployee($event.option.id)">
          <mat-option *ngFor="let partner of filteredValues" [id]="partner.employeeId" [value]="partner.name">
            {{ partner.name }} ({{ partner.employeeId }})
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </div>
  <div mat-dialog-content>
    <div class="form-group pl-3 pr-3">
      <label for="empId">Prev Empid</label>
      <input type="number" class="form-control" id="empId" placeholder="Enter empId"
        [value]="this.data.managerupdate.id" readonly />
    </div>
    <div class="form-group pl-3 pr-3">
      <label for="empName">prev EmpName</label>
      <input type="text" class="form-control" id="empName" placeholder="Enter empName"
        [value]="this.data.managerupdate.name" readonly />
    </div>
    <div class="form-group pl-3 pr-3">
      <label for="empName">current Empid</label>
      <input type="text" class="form-control" id="empName" placeholder="Enter empId"
        [value]="selectedEmployee ? selectedEmployee.employeeId : ''" readonly />
    </div>
    <div class="form-group pl-3 pr-3">
      <label for="empName">current EmpName</label>
      <input type="text" class="form-control" id="empName" placeholder="Enter empName"
        [value]="selectedEmployee ? selectedEmployee.name : ''" readonly />
    </div>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button type="button" [mat-dialog-close]="true" class="btn btn-danger">
      Close
    </button>
    <button [mat-dialog-close]="true" class="btn btn-primary ml-3 mr-4" (click)="onUpdate()">
      Update
    </button>
  </div>
</ng-template>